export const programFailures = {
    "SERVER_ERROR": 500,
}